import abi from "./Transaction.json"
import stackingAbi from "./stacking.json";
import rewardTokenAbi from "./rewardToken.json";

export const stackAbi = stackingAbi.abi;
export const stackAddress = '0x63c724BbD23E686c1395A92339da946F6e377a01';

export const rewardAbi = rewardTokenAbi.abi;
export const rewardTokenAddress = '0xA14c53070b766795b0299EF2A22A3b2563571aB2';

export const contractAddress = "0x6f354b48B120321c34F6b57240F316eb606B8FA5";
export const contractABI = abi.abi;